// extracted by css-extract-rspack-plugin
module.exports =  {"root":"LoadError__root___Yvq0k","message":"LoadError__message___QXGnW","actions":"LoadError__actions___R6O14"};